export default {
    mapper: {
        // BUGS-5570: Overwrites default LOCATION_CHANGE 'page' event
        // and prevents it from being fired every route change
        '@@router/LOCATION_CHANGE': () => {
            return {};
        },
    },
};
